export default __webpack_public_path__ + "static/media/sketchup-logo.8ad95cdc.svg";